<template>
    <div v-click-outside="reset" class="board__column">
        <div class="board__action">
            <div class="quick-action">
                <div v-if="isOpen" class="quick-action__body">
                    <input @keyup.enter="createColumn()"
                           ref="input"
                           :disabled="form.busy"
                           v-model="form.name"
                           class="quick-action__input form__input"
                           :class="{ 'form__input--error' : form.errors.has('name') }"
                           placeholder="Column name"
                           type="text"/>
                    <p v-if="form.errors.has('name')" class="form__help form__help--error">{{ form.errors.get('name') }}</p>
                    <div class="quick-action__controls">
                        <button @click.prevent="reset" :disabled="form.busy" class="button button--outline button--small">Cancel</button>
                        <button @click.prevent="createColumn" :disabled="form.busy" class="button button--primary button--small">Add Column</button>
                    </div>
                </div>
                <div v-else @click.prevent="open" class="quick-action__handler">
                    <icon type="plus" size="16" />
                    Add Column
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* global app */
import { mapState, mapGetters } from 'vuex'
import Icon from '../Global/Icon'
import Form from '../../helpers/Form'

export default {
    data () {
        return {
            isOpen: false,
            form: new Form({
                name: ''
            })
        }
    },

    methods: {
        open () {
            this.isOpen = true

            this.$nextTick(() => {
                this.$refs.input.focus()
            })
        },

        clear () {
            this.form.name = ''
            this.form.errors.forget()
        },

        reset () {
            this.clear()
            this.isOpen = false
        },

        createColumn () {
            this.$store.dispatch('channel/createColumn', this.form).then(() => {
                this.clear()
                this.open()
            })
        }
    },

    computed: {
        ...mapState({
            channel: 'channel/channel'
        }),

        ...mapGetters({
            columns: 'channel/columns'
        })
    },

    components: {
        Icon
    }
}
</script>
